/* eslint-disable */
import React from 'react';
import {PropTypes} from 'prop-types';
import {Card, CardHeader, CardBody, Button, FormGroup, Label, FormFeedback, Row, Col} from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import LaddaButton, {ZOOM_OUT} from 'react-ladda';
import TextEditor from '../../components/TextEditor/TextEditor';
import Section from '../../components/Section';

const GenericTicket = (props) => {

  return (
        <Section title="Generic Ticket">
            <Row className="mx-0">
                <Col className="p-4 bg-white rounded">
                <AvForm onValidSubmit={props.handleValidSubmit} onInvalidSubmit={props.onInvalidSubmit}>
                    <FormGroup>
                        <Label for="ticketTitle">Title</Label>
                        <AvField type="text" name="ticketTitle" id="ticketTitle" placeholder="Title of the ticket" required validate={{maxLength: {value: 200}}}/>
                    </FormGroup>
                    <FormGroup>
                        <Label for="ticketCategory">Category</Label>
                        <AvField type="select" name="ticketCategory" id="ticketCategory" required>
                            <option value="">-- Select</option>
                            <option value="Service Affecting">Service Affecting</option>
                            <option value="Non Service Affecting">Non Service Affecting</option>
                        </AvField>
                    </FormGroup>
                    <FormGroup>
                        <Label for="ticketPriority">Priority</Label>
                        <AvField type="select" name="ticketPriority" id="ticketPriority" required>
                            <option value="">-- Select</option>
                            <option value="low">Low</option>
                            <option value="medium">Medium</option>
                            <option value="high">High</option>
                        </AvField>
                    </FormGroup>
                    <FormGroup>
                        <Label for="ticketDevice">Device ID</Label>
                        <AvField type="text" name="ticketDevice" id="ticketDevice" placeholder="The device ID if known (e.g. cr1.123456.uk)" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="ticketSite">Site</Label>
                        <AvField type="text" name="ticketSite" id="ticketSite" placeholder="The site relevant to this query" />
                    </FormGroup>
                    <FormGroup color={props.descError ? 'danger' : null}>
                        <Label>Description</Label>
                        <TextEditor callback={props.callback} color={props.descError ? 'danger' : null}/>
                        {props.descError && <FormFeedback>Description is a required field</FormFeedback>}
                    </FormGroup>
                    <div className="clearfix" style={{marginTop: `${10}px`, marginBottom: `${20}px`}}>
                        {/* <Button type="submit" color="primary" className="float-right" style={{minWidth: 113+'px', minHeight: 35+'px'}} disabled={props.processing}>{props.processing ?
                            <div style={{marginTop: 2+'px'}}><Loader color="#ffffff" size="8px" margin="0px"/></div> : "Create Ticket"}
                            </Button> */}
                        <LaddaButton
                            style={{minWidth: `${113}px`, minHeight: `${35}px`}}
                            className="btn btn-primary btn-ladda px-4 float-right"
                            disabled={props.processing}
                            loading={props.processing}
                            data-color="blue"
                            data-style={ZOOM_OUT}
                        >
                            Create Ticket
                        </LaddaButton>
                    </div>
                </AvForm>
                </Col>
            </Row>
        </Section>
  );

};
GenericTicket.propTypes = {
  handleValidSubmit: PropTypes.func.isRequired,
  onInvalidSubmit: PropTypes.func.isRequired,
  callback: PropTypes.func.isRequired,
  descError: PropTypes.bool.isRequired,
  processing: PropTypes.bool.isRequired,
};
export default GenericTicket;
